<template>
  <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <div class="box-time" :class="[{ 'no-focus-input': false }, field.options.size]" :style="{color:field.options.disabled?'#ccc':''}">
      <input type="hidden" v-model="fieldModel" />
      <div
        :style="{ 'width': field.options.labelWidth - 12 + 'px', 'text-align': labelAlign, 'padding-right': '12px'}">
        <span v-if="field.options.required" style="color: #F56C6C;">*</span>
        {{ field.options.label }}
      </div>
      <div :style="{ flex: field.options.input1Width }">
        <van-field :disabled="field.options.disabled" :size="field.options.size" :readonly="field.options.readonly"
          v-model="value1" :placeholder="field.options.placeholder" @blur="blurFun1" @focus="focusFlag = true"
          @change="changeFun1"></van-field>
      </div>
      <span class="inner-uint">{{ field.options.unit1 }}</span>
      <div :style="{ flex: field.options.input2Width }">
        <van-field :disabled="field.options.disabled" :size="field.options.size" :readonly="field.options.readonly"
          :style="{ width: field.options.sWidth }" v-model="value2" :placeholder="field.options.placeholder1"
          @blur="blurFun2" @focus="focusFlag = true" @change="changeFun2"></van-field>
      </div>

      <span class="inner-uint">{{ field.options.unit2 }}</span>
    </div>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "@/components/form-designer/form-widget/field-widget/form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n from "@/utils/i18n";
import { isNull } from "@/utils/util";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
export default {
  name: "twoFieldWidget",
  components: {
    FormItemWrapper,
  },
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  inject: ["refList", "globalOptionData", "globalModel"],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  data() {
    return {
      oldFieldValue: null, //field组件change之前的值
      fieldModel: null,
      rules: [],
      // 机构名称树选项
      value1: "",
      value2: "",
      focusFlag: false,
    };
  },
  watch: {
    value1(newVal) {
      if (!this.fieldModel) {
        this.setValue(newVal + "/");
      } else {
        let strs = this.fieldModel.split("/");
        strs[0] = newVal;
        this.setValue(strs.join("/"));
      }
    },
    value2(newVal) {
      if (!this.fieldModel) {
        this.setValue("/" + newVal);
      } else {
        let strs = this.fieldModel.split("/");
        strs[1] = newVal;
        this.setValue(strs.join("/"));
      }
    },
    fieldModel() {
      if (!this.fieldModel) {
        this.fieldModel = "/";
      } else {
        let strs = this.fieldModel.split("/");
        this.value1 = strs[0];
        this.value2 = strs[1];
      }
    },
  },
  computed: {
    labelAlign() {
      return this.field.options.labelAlign.split('-')[1]
    }
  },
  created() {
    this.registerToRefList();
    this.initEventHandler();
    this.initFieldModel();
    this.buildFieldRules();
    if (this.field.options.required) {
      this.rulesF();
    }
    this.addOtherRuls();
  },
  beforeDestroy() {
    this.unregisterFromRefList();
  },
  methods: {
    rulesF() {
      let _this = this;
      this.rules.push({
        validator: function (rule, value, callback, errorMsg) {
          if (isNull(value) || value == "/") {
            callback(new Error(_this.field.options.requiredHint));
            return;
          } else if (isNull(value.split("/")[0]) || value.split("/")[0] == "") {
            callback(new Error(_this.field.options.requiredHint));
            return;
          } else if (isNull(value.split("/")[1]) || value.split("/")[1] == "") {
            callback(new Error(_this.field.options.requiredHint1));
            return;
          }
          callback();
        },
        trigger: ["blur", "change"],
        label: this.field.options.label,
      });
    },

    addOtherRuls() {
      if (
        !(
          isNull(this.field.options.inputRegular1) ||
          this.field.options.inputRegular1 == ""
        )
      ) {
        this.addruls_(this.field.options.inputRegular1, 0);
      }
      if (
        !(
          isNull(this.field.options.inputRegular2) ||
          this.field.options.inputRegular2 == ""
        )
      ) {
        this.addruls_(this.field.options.inputRegular2, 1);
      }
    },

    addruls_(regepx, index_) {
      this.rules.push({
        validator: function (rule, value, callback) {
          //空值不校验
          if (isNull(value) || value == "/") {
            callback();
            return;
          }
          const reg = eval(regepx);
          if (!reg.test(value.split("/")[index_])) {
            let errTxt = rule.errorMsg || "验证不通过，请你输入正确的数据";
            callback(new Error(errTxt));
          } else {
            callback();
          }
        },
        trigger: ["blur", "change"],
        label: this.field.options.label,
      });
    },

    blurFun1() {
      this.focusFlag = false;
      let tmpFunc = new Function("val", this.field.options.onBlur1);
      return tmpFunc.call(this, this.getValue());
    },
    changeFun1() {
      let tmpFunc = new Function("val", this.field.options.onChange1);
      return tmpFunc.call(this, this.getValue());
    },
    blurFun2() {
      this.focusFlag = false;
      let tmpFunc = new Function("val", this.field.options.onBlur2);
      return tmpFunc.call(this, this.getValue());
    },
    changeFun2() {
      let tmpFunc = new Function("val", this.field.options.onChange2);
      return tmpFunc.call(this, this.getValue());
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/vant.scss";

.box-time {
  display: flex;
  align-items: center;
  // border: 1px solid #c5c5c5;
  padding: 0 1px;
  box-sizing: border-box;

  * {
    padding: 0px;
    margin: 0px;
  }
}

.inner-uint {
  // color: #3b3b3b;
  // background: #f5f7fa;
  text-align: right;
  display: block;
  height: calc(100% - 2px);
  padding: 0 4px;
}

.is-error .box-time {
  border-color: #f56c6c;
}

::v-deep .box-time .el-input__inner {
  border: none;
  border-radius: 0;
}

::v-deep .el-form-item--large {
  .el-input__inner {
    line-height: 37px;
    height: 37px;
  }

  .inner-uint {
    line-height: 38px;
  }

  .box-time {
    height: 40px;
  }
}

::v-deep .el-form-item--medium {
  .el-input__inner {
    line-height: 33px;
    height: 33px;
  }

  .inner-uint {
    line-height: 33px;
  }

  .box-time {
    height: 36px;
  }
}

::v-deep .el-form-item--small {
  .el-input__inner {
    line-height: 29px;
    height: 29px;
  }

  .inner-uint {
    line-height: 29px;
  }

  .box-time {
    height: 32px;
  }
}

::v-deep .el-form-item--mini {
  .el-input__inner {
    line-height: 24px;
    height: 24px;
  }

  .inner-uint {
    line-height: 24px;
  }

  .box-time {
    height: 28px;
  }
}

.box-time.mini {
  height: 28px;

  ::v-deep .el-input__inner {
    height: 24px;
    line-height: 24px;
  }

  .inner-uint {
    line-height: 24px;
  }
}

.box-time.small {
  height: 32px;

  ::v-deep .el-input__inner {
    height: 29px;
    line-height: 29px;
  }

  .inner-uint {
    line-height: 29px;
  }
}

.box-time.medium {
  height: 36px;

  ::v-deep .el-input__inner {
    height: 33px;
    line-height: 33px;
  }

  .inner-uint {
    line-height: 33px;
  }
}

.box-time.large {
  height: 40px;

  ::v-deep .el-input__inner {
    height: 37px;
    line-height: 37px;
  }

  .inner-uint {
    line-height: 37px;
  }
}

.inner-uint {
  // width: 23%;
}
</style>